import clsx from 'clsx';
import { FormEvent } from 'react';
import { useController } from 'react-hook-form';
// import LightLoader from 'assets/light-loader.gif';

export const SelectWithoutControl = ({
  options,
  startIcon,
  endIcon,
  defaultVal,
  color = 'brand-sky-blue',
  className,
  containerClass,
  selectType = 'any',
  loading,
  handleChange,
  defaultValue,
  name,
  ...props
}: any) => {
  return (
    <div className="max-h-[45px]">
      <div
        className={clsx(
          'brand-border-light brand-shadow flex gap-x-3 rounded-md border py-[6px] md:py-[4px]',
          startIcon ? 'px-4' : 'px-1',
          containerClass
        )}
      >
        {startIcon && (
          <span className={`my-auto text-${color}`}>{startIcon}</span>
        )}
        {loading ? (
          // <img src={LightLoader} alt="" className="h-8 w-8" />
          <></>
        ) : (
          <select
            {...props}
            className={clsx(
              'w-full cursor-pointer p-[2px] outline-none md:p-1',
              className
            )}
            onChange={(e) => handleChange(e.target.value, name)}
          >
            <option value="" className="italic" hidden>
              {defaultVal}
            </option>
            {options.map((item: any) => (
              <option
                key={typeof item === 'object' ? item.id || item.value : item}
                id={typeof item === 'object' ? item.id || item.value : item}
                value={typeof item === 'object' ? item.id ?? item.value : item}
                disabled={typeof item === 'object' ? item.disabled : undefined}
              >
                {item?.label ?? item}
              </option>
            ))}
          </select>
        )}

        {endIcon && <span className={`my-auto text-${color}`}>{endIcon}</span>}
      </div>
      {/* {error && (
        <small className="text-red-500 text-[10px]">{error?.message}</small>
      )} */}
    </div>
  );
};
const SelectInput = ({
  options,
  startIcon,
  endIcon,
  label,
  color = 'brand-sky-blue',
  className,
  containerClass,
  selectType = 'any',
  loading,
  handleOnChange,
  defaultValue,
  name,
  control,
  readOnly,
  ...props
}: any) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: defaultValue || '',
  });

  const onChange = (e: FormEvent<HTMLInputElement>, field: any) => {
    if (readOnly) return;
    field.onChange(e.currentTarget.value);
    handleOnChange?.(e.currentTarget.value || '', name);
  };

  return (
    <div className="max-h-[45px]">
      <div
        className={clsx(
          'flex gap-x-3 rounded-md border border-stone-300 py-3 md:py-[4.5px]',
          startIcon ? 'px-4' : 'px-1',
          containerClass
        )}
      >
        {startIcon && (
          <span className={`my-auto text-${color}`}>{startIcon}</span>
        )}
        {loading ? (
          // <img src={LightLoader} alt="" className="h-8 w-8" />
          <></>
        ) : (
          <select
            {...field}
            onChange={(e: FormEvent<HTMLInputElement>) => onChange(e, field)}
            {...props}
            className={clsx(
              'w-full cursor-pointer p-[2px] outline-none md:p-1',
              className
            )}
          >
            {label && (
              <option value="" className="italic" hidden>
                {label}
              </option>
            )}
            {options.map((item: any) => (
              <option
                key={
                  typeof item === 'object'
                    ? item?._id || item.id || item.value
                    : item
                }
                id={
                  typeof item === 'object'
                    ? item?._id || item.id || item.value
                    : item
                }
                value={typeof item === 'object' ? item.id ?? item.value : item}
                disabled={typeof item === 'object' ? item.disabled : undefined}
              >
                {item?.label ?? item}
              </option>
            ))}
          </select>
        )}

        {endIcon && <span className={`my-auto text-${color}`}>{endIcon}</span>}
      </div>
      {error && (
        <small className="text-[10px] text-red-500">{error?.message}</small>
      )}
    </div>
  );
};

export default SelectInput;
